import useSWR, { mutate } from "swr";

export const BackgroundProcessStatus = {
  idle: "idle",
  running: "running",
  completed: "completed",
  failed: "failed",
} as const;

export type ChordsheetPersistenceStatus =
  (typeof BackgroundProcessStatus)[keyof typeof BackgroundProcessStatus];

const STATUS_KEY = "chordsheet-persistence-status";

let currentStatus: ChordsheetPersistenceStatus = BackgroundProcessStatus.idle;

export const chordsheetPersistenceState = {
  getStatus(): ChordsheetPersistenceStatus {
    return currentStatus;
  },
  setStatus(status: ChordsheetPersistenceStatus) {
    currentStatus = status;
    // Pushes the status into SWR's cache so every mounted
    // useChordsheetPersistenceStatus() re-renders with it.
    void mutate(STATUS_KEY, status, { revalidate: false });
  },
};

export function useChordsheetPersistenceStatus(): ChordsheetPersistenceStatus {
  const { data } = useSWR<ChordsheetPersistenceStatus>(STATUS_KEY, null, {
    fallbackData: currentStatus,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });
  return data ?? currentStatus;
}
